import {Utils} from '@busuu/legacy-core';
import DiscountService from 'discount/discount-service.js';
import SharedDataService from 'data/shared-data-service.js';
import DiscountVoucherUI from 'forms/discount-voucher-class.js';
import {storeEcommerceOriginValue} from '@busuu/marketing';
import Tracking from 'tracking/tracking-controller.ts';

/**
 * The discount form request a discount value
 * to the Backend using the plans API.
 * If success, we store the discount and redirect
 * the user to the /n/plans page (/premium).
 * It's different from the voucher form where
 * it actually make a user premium straight after it.
 */

const discountForm = Utils.getById('discountForm');
const discountInput = Utils.getById('discountInput');
let discountUI = null;

/**
 * XHR
 */
const onSuccess = (response) => {
    SharedDataService.storeDiscountCoupon(response.coupon);
    storeEcommerceOriginValue('DISCOUNT_COUPON_FORM');
    Tracking.send('DISCOUNT_COUPON_FORM_SUCCESS', {discount_coupon: response.coupon, discount_amount: response.saving});
    window.location.href = discountForm.getAttribute('action');
};

const onError = (error = {}) => {
    let trs = null;
    switch (error.type) {
        case 'COUPON_MISSING':
            trs = 'FIELD_REQUIRED';
            break;
        case 'COUPON_API_RESPONSE_MALFORMED':
        case 'COUPON_UNAVAILABLE_OR_NOT_FOUND':
        case 'COUPON_API_CALL_FAILED':
        default:
            trs = 'NOT_VALID_DISCOUNT_CODE';
            break;
    }
    Tracking.send('DISCOUNT_COUPON_FORM_ERROR', {error: error.type});
    discountUI.showErrorAndEnableForm(trs);
};

const onRequestStart = () => {
    discountUI.hideErrorsAndDisableForm();
};

const onFormSubmit = (e) => {
    e.preventDefault();
    onRequestStart();
    Tracking.send('DISCOUNT_COUPON_FORM_SUBMITTED', {discount_coupon: Utils.clean(discountInput.value)});
    DiscountService.getCouponValidity(discountInput.value).then(onSuccess).catch(onError);
};

const init = () => {
    // Discount form exists as a module so we need to check which page the user is on
    const isOnDiscountPage = /busuu\.com\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?discount(?:\?.*)?$/.test(window.location.href);
    const viewType = isOnDiscountPage ? 'page' : 'modular';

    if (!discountForm) {
        return false;
    }
    // Send view event
    Tracking.send('DISCOUNT_COUPON_FORM_VIEWED', {type: viewType});

    discountUI = new DiscountVoucherUI(Utils.getById('discountSubmit'), Utils.getById('discountError'));
    discountForm.addEventListener('submit', onFormSubmit);
};

init();
